import { useEffect } from 'react';
import { useSummarizer } from '@core/store/useSummarizer';
import { CustomPromptDialog } from './CustomPromptDialog';
import { PromptLibrary } from './PromptLibrary';
import { PromptDetailView } from './PromptDetailView';

export const RepurposeTab: React.FC = () => {
  const {
    currentSummary,
    activePrompt,
    showCustomPromptModal,
    setShowCustomPromptModal,
    addPrompt,
    prompts,
    isLoadingPromptLibrary,
    fetchPromptLibrary,
  } = useSummarizer();

  // Fetch prompt library when tab opens, but only if prompts are empty
  useEffect(() => {
    // Only fetch if:
    // 1. Prompts array is empty
    // 2. Not currently loading
    // 3. We haven't tried to fetch yet (prompts.length === 0 indicates no attempt)
    if (prompts.length === 0 && !isLoadingPromptLibrary) {
      fetchPromptLibrary();
    }
  }, []); // Empty dependency array - only run once when component mounts

  const handleCreatePrompt = (title: string, prompt: string) => {
    addPrompt({ title, prompt, description: '' });
    setShowCustomPromptModal(false);
  };

  if (!currentSummary) {
    return <div>No summary available.</div>;
  }

  if (activePrompt) {
    return <PromptDetailView summary={currentSummary} />;
  }

  return (
    <div className="h-full flex flex-col">
      <PromptLibrary />
      <CustomPromptDialog
        isOpen={showCustomPromptModal}
        onClose={() => setShowCustomPromptModal(false)}
        onSubmit={handleCreatePrompt}
        isSubmitting={false}
      />
    </div>
  );
};
